<div class="landing-wrapper">

    <!-- HERO SECTION -->
    <section class="hero-section">
        <div class="hero-container">

            <!-- Linker kolom: Boodschap & Conversie -->
            <div class="hero-content">
                <h1 class="hero-title">
                    Turn conversations <br>
                    <span class="highlight-text">into action.</span>
                </h1>

                <p class="hero-subtitle">
                    <strong class="brand-bold">Your</strong>Notes brings your calendar, meeting notes, and tasks
                    together in one connected workspace. Capture what matters, turn notes into actionable tasks, and
                    always know what needs your attention next. Pick up where you left off, on any device, with
                    everything
                    automatically synced between web and mobile. <strong class="brand-bold">Because every meeting
                        deserves a next step.</strong>
                </p>

                <div class="cta-group">
                    <button class="btn-primary" (click)="registerModal()">Start free trial</button>
                    <a routerLink="/keyconcepts" class="btn-secondary">Explore Features</a>
                </div>

                <div class="mobile-app-banner">
                    <p class="app-banner-title">Or download the mobile app:</p>
                    <div class="store-badges">
                        <a href="https://apps.apple.com/app/id6768758842" target="_blank" rel="noopener"
                            class="store-badge">
                            <mat-icon>apple</mat-icon>
                            <div class="badge-text">
                                <small>Download on the</small>
                                <strong>App Store</strong>
                            </div>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.yournotes.nl" target="_blank"
                            rel="noopener" class="store-badge">
                            <mat-icon>android</mat-icon>
                            <div class="badge-text">
                                <small>GET IT ON</small>
                                <strong>Google Play</strong>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="hero-highlights">
                    <span><mat-icon>event_repeat</mat-icon> Calendar integration</span>
                    <span><mat-icon>description</mat-icon> Actionable notes</span>
                    <span><mat-icon>check_circle_outline</mat-icon> Tasks & Todo lists</span>
                </div>
            </div>

            <div class="hero-visual">
                <div class="visual-wrapper">
                    <div class="glow-bg"></div>

                    <!-- MAIN APP WINDOW (Geïnspireerd op Web App UI) -->
                    <div class="app-card main-dashboard">
                        <!-- HEADER BAR -->
                        <div class="app-header">
                            <div class="brand-title">
                                <span class="logo-text">YourNotes</span>
                                <small>Organise. Prioritise. Deliver.</small>
                            </div>
                            <div class="header-right">
                                <span class="theme-toggle"></span>
                                <mat-icon class="user-avatar">account_circle</mat-icon>
                            </div>
                        </div>

                        <!-- MAIN APP BODY -->
                        <div class="app-body">
                            <!-- ICON SIDEBAR (Ingegeven door web screenshots) -->
                            <div class="icon-sidebar">
                                <mat-icon class="active">dashboard</mat-icon>
                                <mat-icon>description</mat-icon>
                                <mat-icon>bar_chart</mat-icon> <!-- Tasks / Kanban -->
                                <mat-icon>playlist_add_check</mat-icon> <!-- Checklists -->
                                <div class="sidebar-bottom">
                                    <mat-icon>settings</mat-icon>
                                    <mat-icon>exit_to_app</mat-icon>
                                </div>
                            </div>

                            <!-- WORKSPACE CONTENT (Gedistribueerd over de 4 modules) -->
                            <div class="workspace-grid">

                                <!-- 1. DASHBOARD / WEEK OVERVIEW -->
                                <div class="module-card agenda-module">
                                    <div class="module-header">
                                        <span><mat-icon>calendar_month</mat-icon> Week overview</span>
                                        <span class="date-range">Sep 14 - Sep 20</span>
                                    </div>
                                    <div class="calendar-strip">
                                        <div class="all-day-banner">Team Sync Week</div>
                                        <div class="time-slot">
                                            <span class="time">09:30</span>
                                            <div class="event blue">Design System Review</div>
                                        </div>
                                        <div class="time-slot">
                                            <span class="time">13:00</span>
                                            <div class="event blue">Client Onboarding Call</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 2. NOTES TREE & EDITOR -->
                                <div class="module-card notes-module">
                                    <div class="module-header">
                                        <span><mat-icon>folder_open</mat-icon> Workspace Notes</span>
                                    </div>
                                    <div class="notes-tree">
                                        <div class="search-input">
                                            <mat-icon>search</mat-icon> Search notes...
                                        </div>
                                        <div class="tree-node folder"><mat-icon>folder</mat-icon> Product Team</div>
                                        <div class="tree-node note active"><mat-icon>description</mat-icon> Q4 Roadmap
                                            Ideas</div>
                                        <div class="tree-node note"><mat-icon>description</mat-icon> Sprint
                                            Retrospective</div>
                                    </div>
                                </div>

                                <!-- 3. TASKS / KANBAN BOARD -->
                                <div class="module-card tasks-module">
                                    <div class="module-header">
                                        <span><mat-icon>view_kanban</mat-icon> In Progress (3)</span>
                                    </div>
                                    <div class="task-cards">
                                        <div class="kanban-card">
                                            <strong>Task: Mobile UI polish</strong>
                                            <small>Due: Sep 18, 2026</small>
                                        </div>
                                        <div class="kanban-card">
                                            <strong>Task: Setup API endpoints</strong>
                                            <small>Due: Sep 20, 2026</small>
                                        </div>
                                    </div>
                                </div>

                                <!-- 4. CHECKLISTS / TODO LIST -->
                                <div class="module-card checklist-module">
                                    <div class="module-header">
                                        <span><mat-icon>check_box</mat-icon> Sprint Checklists</span>
                                    </div>
                                    <div class="progress-bar-container">
                                        <div class="progress-fill" style="width: 75%;"></div>
                                    </div>
                                    <small class="progress-text">12 of 16 completed (75%)</small>

                                    <div class="todo-items">
                                        <div class="todo-item">
                                            <mat-icon class="checkbox">check_box_outline_blank</mat-icon>
                                            <span>Update dark mode tokens</span>
                                            <mat-icon class="delete-icon">delete_outline</mat-icon>
                                        </div>
                                        <div class="todo-item done">
                                            <mat-icon class="checkbox">check_box</mat-icon>
                                            <span>Fix responsive layout issue</span>
                                            <mat-icon class="delete-icon">delete_outline</mat-icon>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- FLOATING SYNC CARD -->
                    <div class="app-card mobile-sync-card">
                        <mat-icon class="pulse-icon">phonelink</mat-icon>
                        <div class="sync-text">
                            <strong>Seamless Sync</strong>
                            <p>Web, iOS & Android</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="scroll-indicator" (click)="scrollToFeatures()">
            <span>Discover features</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
    </section>

    <!-- WHY YOURNOTES SECTION -->
    <section class="info-section" id="why-section">
        <div class="container text-center">
            <h2>Why YourNotes?</h2>
            <p class="section-lead">Work moves fast. Your tools should keep up.</p>

            <div class="why-grid">
                <div class="why-card">
                    <mat-icon class="icon-large">hub</mat-icon>
                    <h3>Everything Connected</h3>
                    <p>Every note, task and follow-up stays connected to the meeting it came from. See the discussion,
                        decisions, and action points behind your work whenever you need.</p>
                </div>
                <div class="why-card">
                    <mat-icon class="icon-large">search</mat-icon>
                    <h3>No More Digging</h3>
                    <p>Stop searching through meeting notes, emails, or multiple apps to find what you're looking for.
                        Everything lives in a single dashboard.</p>
                </div>
                <div class="why-card">
                    <mat-icon class="icon-large">bolt</mat-icon>
                    <h3>Action-Oriented</h3>
                    <p>Staying on top of your work isn't about taking more notes. It's about turning notes into action
                        with total confidence.</p>
                </div>
            </div>
        </div>
    </section>

    <!-- HOW IT WORKS SECTION -->
    <section class="how-section">
        <div class="container">
            <h2 class="text-center">How it works</h2>
            <div class="steps-grid">
                <div class="step-card">
                    <div class="step-number">1</div>
                    <h3>Capture</h3>
                    <p>Connect your calendar and take notes during meetings, calls, and daily work. Keep recurring
                        meetings organized with all previous notes at your fingertips.</p>
                </div>
                <div class="step-card">
                    <div class="step-number">2</div>
                    <h3>Prioritise</h3>
                    <p>Turn key decisions and action points into tasks in a single click. View everything in your
                        dashboard, task lists, or Kanban board.</p>
                </div>
                <div class="step-card">
                    <div class="step-number">3</div>
                    <h3>Deliver</h3>
                    <p>Receive reminders, track progress, and follow through on commitments. No lost notes, forgotten
                        actions, or missed deadlines.</p>
                </div>
            </div>
        </div>
    </section>

    <!-- FEATURES LIST SECTION -->
    <section class="features-section">
        <div class="container">
            <h2 class="text-center">Everything you need to turn conversations into action</h2>

            <div class="features-checklist">
                <div class="check-item"><mat-icon class="check-icon">check_circle</mat-icon>
                    <div><strong>Never miss a meeting:</strong> Connect your Microsoft or Google Calendar</div>
                </div>
                <div class="check-item"><mat-icon class="check-icon">check_circle</mat-icon>
                    <div><strong>Capture what matters:</strong> Create meeting notes and keep recurring conversations
                        connected</div>
                </div>
                <div class="check-item"><mat-icon class="check-icon">check_circle</mat-icon>
                    <div><strong>Turn decisions into tasks:</strong> Create action items directly from your notes</div>
                </div>
                <div class="check-item"><mat-icon class="check-icon">check_circle</mat-icon>
                    <div><strong>Always know what's next:</strong> See tasks, meetings, and priorities in one dashboard
                    </div>
                </div>
                <div class="check-item"><mat-icon class="check-icon">check_circle</mat-icon>
                    <div><strong>Stay on top of follow-ups:</strong> Receive reminders for upcoming events and overdue
                        tasks</div>
                </div>
                <div class="check-item"><mat-icon class="check-icon">check_circle</mat-icon>
                    <div><strong>Find anything instantly:</strong> Search across your notes and meeting history</div>
                </div>
                <div class="check-item"><mat-icon class="check-icon">check_circle</mat-icon>
                    <div><strong>Work anywhere:</strong> Stay synced across web and mobile</div>
                </div>
            </div>
        </div>
    </section>

    <!-- WHO IS IT FOR SECTION -->
    <section class="target-section">
        <div class="container text-center">
            <h2>Who is YourNotes for?</h2>
            <p class="target-desc">
                YourNotes is for anyone who wants to stay organized without juggling multiple apps.
                From meeting notes and follow-ups to projects, study notes, and personal tasks—everything stays
                connected in one workspace, helping you stay focused, organized, and in control.
            </p>
        </div>
    </section>

    <!-- CLOSING CTA SECTION -->
    <section class="cta-banner">
        <div class="container text-center">
            <h2>Because great meetings don't end with notes. They end with action.</h2>
            <p>Every meeting deserves a next step.</p>
            <button class="btn-primary large" (click)="registerModal()">Start your free trial today</button>
        </div>
    </section>

    <!-- FOOTER -->
    <footer class="hero-footer">
        <div class="footer-links">
            <a routerLink="/terms">Terms & Conditions</a>
            <span class="separator">&nbsp;•&nbsp;</span>
            <a routerLink="/privacy">Privacy Policy</a>
        </div>
        <div class="copyright">
            &copy; 2026 YourNotes. All rights reserved.
        </div>
    </footer>

</div>